import { isGlobalManager, isLocalMarketNewsReviewer } from "../roles/authFunctions"

/** create and delete entries */
export const hasNewsManagerAccess = (groups: string | undefined): boolean => isGlobalManager(groups ?? "")

/** list, read and update entries */
export const hasNewsAccess = (groups: string | undefined): boolean =>
	hasNewsManagerAccess(groups) || isLocalMarketNewsReviewer(groups ?? "")
